<template>
  <div class="login-phone-other-container">
    <div class="content">
      <div class="head">
        <div class="close" @click="$router.back()"></div>
        <div class="title">手机号登录</div>
      </div>
      <div class="box">
        <div class="t1">登录体验更多欢乐</div>
        <div class="t2">请输入您的手机号</div>
        <div class="form">
          <div class="cell">
            <div class="prefix">+{{ prefix }}</div>
            <Field
              class="input"
              v-model="phone"
              type="tel"
              placeholder="请输入手机号"
              maxlength="11"
              autofocus
            />
          </div>
          <Button class="btn" @click="nextHandle" :loading="loading"
            >下一步</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Field, Toast, Button } from 'vant'
export default {
  components: { Field, Button },
  data() {
    return {
      loading: false,
      phone: null,
      prefix: 86,
    }
  },
  created() {
    this.phone = this.$store.state.sms.code_phone || null
  },
  computed: {
    ...mapState({
      code_timeout: (state) => state.sms.code_timeout,
      code_phone: (state) => state.sms.code_phone,
      code_flag: (state) => state.sms.code_flag,
    }),
  },
  methods: {
    nextHandle() {
      if (/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.phone)) {
        this.$router.push({
          name: 'LoginPhonePassword',
          query: {  ...this.$route.query, phone: this.phone },
        })
      } else {
        Toast.fail('请输入正确的手机号')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.close {
  display: inline-block;
  width: 30px;
  height: 4px;
  background: #333;
  border-radius: 4px;
  transform: rotate(45deg);
  &::after {
    content: '';
    display: block;
    width: 30px;
    height: 4px;
    background: #333;
    border-radius: 4px;
    transform: rotate(-90deg);
  }
}
.login-phone-other-container {
  height: 100vh;
  width: 100vw;
  .content {
    width: 100%;
    padding: 0 40px;
  }
  .head {
    display: flex;
    align-items: center;
    padding: 30px 0;
    .title {
      flex: 1;
      font-size: 28px;
      line-height: 1;
      text-indent: -20px;
    }
  }
  .box {
    padding-top: 40px;
    text-align: left;
    .t1 {
      font-size: 36px;
      line-height: 28px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    .t2 {
      font-size: 24px;
      line-height: 28px;
      color: #808080;
    }
    .form {
      .cell {
        display: flex;
        padding-top: 32px;
        padding-bottom: 8px;
        border-bottom: 2px solid #aeaeae;
        .prefix {
          display: inline-block;
          position: relative;
          font-size: 36px;
          font-weight: 600;
          padding-right: 34px;
          &::after {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(-50%, -50%);
            display: inline-block;
            content: '';
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid #333333;
          }
        }
        .input {
          flex: 1;
          padding: 0 20px;
          font-size: 36px;
          &::placeholder {
            color: #aeaeae;
          }
        }
      }
      .btn {
        margin-top: 80px;
        width: 100%;
        background: #e82035;
        line-height: 82px;
        border-radius: 50px;
        font-size: 26px;
        text-align: center;
        color: #fff;
      }
    }
  }
}
.popup {
  display: flex;
  flex-direction: column;
  text-align: left;
  overflow: hidden;
  .popupHead {
    display: flex;
    align-items: center;
    padding: 30px 20px;
    .title {
      display: inline-block;
      padding-left: 30px;
      line-height: 40px;
      font-weight: bold;
    }
  }
  .indexAnchorStatic,
  .indexAnchor {
    padding-left: 32px;
    padding-top: 30px;
    font-weight: bold;
  }
  .indexAnchorStatic {
    position: absolute;
    top: 96px;
    width: 100%;
    z-index: 99;
    background: #fff;
  }
  .popupBody {
    position: relative;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }
}
</style>